(function () {
  const PAGES = window.LOOKBOOK_PAGES || [];
  if (!PAGES.length) return;

  const book = document.getElementById('book');
  const stage = document.getElementById('stage');
  const counter = document.getElementById('counter');
  const btnPrev = document.getElementById('btnPrev');
  const btnNext = document.getElementById('btnNext');
  const zonePrev = document.getElementById('zonePrev');
  const zoneNext = document.getElementById('zoneNext');
  const hint = document.getElementById('hint');

  PAGES.forEach((src, i) => {
    const page = document.createElement('div');
    page.className = 'page';
    page.dataset.index = i;
    page.style.zIndex = String(PAGES.length - i);
    page.innerHTML =
      '<div class="page__face page__face--front">' +
        '<img src="' + src + '" alt="Page ' + (i + 1) + '" loading="' + (i < 3 ? 'eager' : 'lazy') + '" decoding="async">' +
        '<div class="page__shade page__shade--front"></div>' +
      '</div>' +
      '<div class="page__face page__face--back">' +
        '<span class="watermark">Omorose</span>' +
        '<div class="page__shade page__shade--back"></div>' +
      '</div>';
    book.appendChild(page);
  });

  let currentIndex = 0;
  let animating = false;
  let firstInteraction = false;

  function pad(n) { return String(n).padStart(2, '0'); }

  function updatePageVisibility() {
    const pages = book.querySelectorAll('.page');
    pages.forEach(function (page, i) {
      const dist = Math.abs(i - currentIndex);
      if (dist <= 1) {
        page.classList.add('is-near');
        page.classList.remove('is-far');
      } else {
        page.classList.add('is-far');
        page.classList.remove('is-near');
      }
    });
  }

  function updateUI() {
    counter.innerHTML = pad(currentIndex + 1) + '<span class="counter__rule"></span>' + pad(PAGES.length);
    btnPrev.disabled = currentIndex === 0;
    btnNext.disabled = currentIndex === PAGES.length - 1;
    zonePrev.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');
    zoneNext.setAttribute('aria-disabled', currentIndex === PAGES.length - 1 ? 'true' : 'false');
    if (currentIndex === 0) {
      stage.classList.add('cover');
      document.body.classList.add('cover');
    } else {
      stage.classList.remove('cover');
      document.body.classList.remove('cover');
    }
    if (currentIndex === PAGES.length - 1) {
      document.body.classList.add('is-last');
    } else {
      document.body.classList.remove('is-last');
    }
    updatePageVisibility();
  }

  function dismissHint() {
    if (!firstInteraction) {
      firstInteraction = true;
      hint.classList.add('hidden');
    }
  }

  function onPageTransformEnd(page, cb) {
    function handler(e) {
      if (e.target !== page || e.propertyName !== 'transform') return;
      page.removeEventListener('transitionend', handler);
      cb();
    }
    page.addEventListener('transitionend', handler);
  }

  function next() {
    if (animating) return;
    if (currentIndex >= PAGES.length - 1) return;
    dismissHint();
    animating = true;
    const page = book.querySelector('.page[data-index="' + currentIndex + '"]');
    page.classList.add('flipped');
    onPageTransformEnd(page, function () { animating = false; });
    currentIndex += 1;
    updateUI();
  }

  function prev() {
    if (animating) return;
    if (currentIndex <= 0) return;
    dismissHint();
    animating = true;
    currentIndex -= 1;
    const page = book.querySelector('.page[data-index="' + currentIndex + '"]');
    page.classList.remove('flipped');
    onPageTransformEnd(page, function () { animating = false; });
    updateUI();
  }

  btnNext.addEventListener('click', next);
  btnPrev.addEventListener('click', prev);
  zoneNext.addEventListener('click', next);
  zonePrev.addEventListener('click', prev);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'PageDown') {
      e.preventDefault();
      next();
    } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
      e.preventDefault();
      prev();
    } else if (e.key === 'Home') {
      while (currentIndex > 0 && !animating) prev();
    } else if (e.key === 'End') {
      while (currentIndex < PAGES.length - 1 && !animating) next();
    }
  });

  let touchStartX = null;
  let touchStartY = null;
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) next();
      else prev();
    }
    touchStartX = null;
    touchStartY = null;
  });

  setTimeout(dismissHint, 6500);

  updateUI();
})();
